import React, { useCallback, useEffect, useState } from "react"
import _ from "lodash"

import CreditSlabs from "../components/credit_slabs"
import * as PricingHelpers from "./../helpers/helpers"
import * as PricingConstants from "./../helpers/constant"
import CreditCalculator from "../components/credit_calculator"

const initialState = {
  selectedSlab: null,
  creditValue: 0,
  minCredit: 0,
  slabs: [],
  billingPrice: 0,
}

const PayAsYouGoCredits = ({ addons }) => {
  const [state, setState] = useState(initialState)

  const setInitialSelectedSlab = useCallback(
    slab => {
      let selectedSlab = { ...slab }

      setState(prevState => ({
        ...prevState,
        selectedSlab,
      }))
    }, [])

  const calcPrice = useCallback(
    credits => {
      if (credits > 0) {
        let price = PricingHelpers.calculatePayAsYouGoAddonAmount(
          addons[0],
          credits
        )

        setState(prevState => ({
          ...prevState,
          billingPrice: price.amount,
        }))
      } else {
        setState(prevState => ({
          ...prevState,
          billingPrice: 0,
        }))
      }
    },
    [addons]
  )

  useEffect(() => {
    const addon = addons[0]

    const slabOptions = _.get(addon, "dropdown_options", [])
    const defaultSlab = _.find(slabOptions, option =>
      _.get(option, "data.selected")
    )

    const minCredit = +_.first(slabOptions).value || 5000

    setState(prevState => ({
      ...prevState,
      slabs: slabOptions,
      creditValue: defaultSlab.data.min,
      minCredit,
    }))

    calcPrice(defaultSlab.data.min)
    setInitialSelectedSlab(defaultSlab)
  }, [addons, calcPrice, setInitialSelectedSlab])

  const handleSlabSelect = slab => {
    // if (state.minCredit > slab.data.min) {
    //   slab.data.min = state.minCredit
    // }

    // if (slab.data.min > PricingConstants.MAX_CREDIT_BUY) {
    //   slab.data.min = PricingConstants.MAX_CREDIT_BUY
    // }

    setState(prevState => ({
      ...prevState,
      creditValue: +slab.value,
    }))

    calcPrice(slab.value)
  }

  const onClickSlabSelect = plan => {
    document.getElementById("credits-input").focus()
    setState(prevState => ({
      ...prevState,
      selectedSlab: plan,
    }))
    handleSlabSelect(plan)
  }

  const onSlabSelect = val => {
    if (val < state.minCredit) val = state.minCredit

    let plan = PricingHelpers.calculatePayAsYouGoAddonAmount(addons[0], val)

    if (state.minCredit > plan.slab.min) {
      plan.slab.min = state.minCredit
    }

    setState(prevState => ({
      ...prevState,
      selectedSlab: plan.slab,
    }))
  }

  const onCalculatorValueChange = val => {
    setState(prevState => ({
      ...prevState,
      creditValue: val,
    }))
    onSlabSelect(val)
    calcPrice(val)
  }

  return (
    <div className="credits-container">
      <CreditSlabs
        slabs={state.slabs}
        selectedSlab={state.selectedSlab}
        onClickSlabSelect={onClickSlabSelect}
      />
      <CreditCalculator
        creditValue={state.creditValue}
        onCalculatorValueChange={onCalculatorValueChange}
        currency={PricingConstants.CURRENCY.USD.name}
        billingPrice={state.billingPrice}
        selectedSlab={state.selectedSlab}
      />
      <div className="credit-note-box mt-3">
        <ul className="mb-0">
          <li>
            To learn{" "}
            <span className="textStyle">
              how credits are charged and billed
            </span>
            ,{" "}
            <a
              href="/pricing-guide/#understand-clearout-credits"
              className="pay-as-you-anchor"
              target="empty"
            >
              Click here&nbsp;<i class="fa fa-external-link"></i>
            </a>
          </li>
          <li>
            For custom or more than{" "}
            <span className="textStyle">20&nbsp;million</span> credits, contact
            us on chat or mail us at&nbsp;
            <a href="mailto:us@clearout.io" className="anchorColor">
              us@clearout.io
            </a>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default PayAsYouGoCredits
